import { Button, Result } from 'antd';
import React from 'react';
import { history, useIntl } from 'umi';

const NoAccessiblePage: React.FC = () => {
  const intl = useIntl();

  return (
    <Result
      status="403"
      title="403"
      subTitle={intl.formatMessage({
        id: 'pages.403.description',
        defaultMessage: 'Sorry, you are not authorized to access this page.',
      })}
      extra={
        <Button type="primary" onClick={() => history.push('/')}>
          Back Home
        </Button>
      }
    />
  );
};

export default NoAccessiblePage;
